var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"pa-0 ma-1",attrs:{"slot":"activator","small":"","icon":"","color":"warning"},slot:"activator"},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.icon || 'edit'))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }